import { AxiosResponse } from 'axios';
import VersionedResource from '../VersionedResource';
import { RelationshipClassificationRule } from './RelationshipClassificationRule';

export default class RelationshipClassificationRuleResource extends VersionedResource {
  public async getAll(fiId: string): Promise<RelationshipClassificationRule[]> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/config/${fiId}/relationship-classification-rule`);
    const rules: RelationshipClassificationRule[] = response.data.data;
    return rules;
  }

  public async save(fiId: string, rule: RelationshipClassificationRule): Promise<RelationshipClassificationRule> {
    const url = `/api/rcx/config/${fiId}/relationship-classification-rule`;
    let response: AxiosResponse;

    const toSave: any = {};
    Object.assign(toSave, rule);

    if (rule.id) {
      response = await this.apiClient.put(`${url}/${rule.id}`, toSave);
    } else {
      response = await this.apiClient.post(url, toSave);
    }

    const savedRule: RelationshipClassificationRule = response.data.data;
    return savedRule;
  }

  public async remove(fiId: string, ruleId: number): Promise<AxiosResponse> {
    return this.apiClient.delete(`/api/rcx/config/${fiId}/relationship-classification-rule/${ruleId}`);
  }
}
